import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Button } from '@mui/material';
import React from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import ActionBubbleTooltip from '../ActionBubbleTooltip';
import { buildPaywallUrl } from '../../helpers/paywall';
import { planQuotaPeriodLabel } from '../../helpers/planLimits';
import { usePlanQuota } from '../../helpers/planUsage';

/** "Você já usou 10 de 10 clientes por mês do seu plano." */
export function quotaBlockedMessage(entry) {
    if (!entry) {
        return 'Você atingiu um limite do seu plano.';
    }
    const label = String(entry.label || '').toLowerCase();
    const scope = planQuotaPeriodLabel(entry.period);
    return `Você já usou ${entry.used} de ${entry.limit} ${label} ${scope} do seu plano. Faça upgrade para continuar cadastrando.`;
}

/**
 * Botão de criação que trava quando a cota do plano acabou, evitando que o
 * usuário preencha um formulário inteiro para descobrir o limite ao salvar.
 * Travado, o clique leva para os planos em vez de abrir o formulário.
 *
 * Passe `to` para navegar ou `onClick` para abrir um modal.
 */
export default function QuotaLimitedButton({
    quotaKey,
    to,
    onClick,
    children,
    startIcon,
    sx,
    ...buttonProps
}) {
    const navigate = useNavigate();
    const location = useLocation();
    const { blocked, entry } = usePlanQuota(quotaKey);

    if (!blocked) {
        const linkProps = to ? { component: RouterLink, to } : {};
        return (
            <Button {...buttonProps} {...linkProps} sx={sx} startIcon={startIcon} onClick={onClick}>
                {children}
            </Button>
        );
    }

    const goToPlans = () => {
        navigate(buildPaywallUrl({ returnTo: to || location.pathname }));
    };

    return (
        <ActionBubbleTooltip title={quotaBlockedMessage(entry)}>
            <Button
                {...buttonProps}
                color="warning"
                startIcon={<LockOutlinedIcon />}
                onClick={goToPlans}
                // O sx de quem chama pode fixar uma cor própria, então a cor de
                // bloqueio vem depois para o botão travado não parecer normal.
                sx={[
                    ...(Array.isArray(sx) ? sx : [sx]),
                    buttonProps.variant === 'contained' && ((theme) => ({
                        backgroundColor: theme.palette.warning.main,
                        color: theme.palette.warning.contrastText,
                        '&:hover': { backgroundColor: theme.palette.warning.dark },
                    })),
                ]}
            >
                {children}
            </Button>
        </ActionBubbleTooltip>
    );
}
